import { getCountLabel } from '../utils/helpers';

export const SUMMARY_PANEL_TITLE = 'Your send';

export const MSKU_OPTIONS_LABEL = 'Options · recipient picks one';

export const MSKU_OPTION_UNAVAILABLE_LABEL = 'Currently unavailable';

export const OPTIONS_CHECK_LABEL = 'Checking available options…';
export const OPTIONS_CHECK_ERROR_LABEL = 'Could not load options';
export const OPTIONS_CHECK_RETRY_LABEL = 'Retry';

export const mskuOptionsToggleLabel = (expanded: boolean, count: number): string =>
  `${expanded ? 'Hide' : 'Show'} ${count} option${count === 1 ? '' : 's'}`;

export const LOCATION_MSKU_BREAKDOWN_LABEL = 'Option breakdown';

export const REMOVE_FROM_SEND_TOOLTIP = 'Remove from send';

export const getItemModeLockLabel = (isMarketplace: boolean, scope = 'kit'): string =>
  `Locked to ${isMarketplace ? 'Marketplace' : 'your inventory'} · one source per ${scope}`;

export const PYG_CONVERSION_BANNER = {
  title: 'Now in Pick your gift mode',
  body: 'Recipients now choose just one option',
} as const;

export const ITEM_BACKORDER_BANNER = "One or more items are on backorder. They'll ship when available.";

export const ITEM_OUT_OF_STOCK_BANNER = 'One or more items are out of stock. Remove or change quantity to continue.';

export const EDIT_KIT_CONFIRM = {
  title: 'Edit this kit?',
  message: 'Your curated kit will become a custom kit so you can edit each item',
  confirmButtonText: 'Edit',
} as const;

export const getRemovedLabel = (name: string): string => `${name} removed`;

export const getUnsetItemsLabel = (count: number): string => `${getCountLabel(count, 'item', 'items')} not set`;
